<template>
  <v-container grid-list-xl fluid>
    <v-layout wrap align-content-space-between justify-space-between>
      <v-flex xs12 sm2>
        <v-btn
          color="primary"
          @click="create"
          class="mb-4"
          :disabled="!hasCondominioAccess(entity, 'create')"
        >
          {{ this.translate("system.button.add.title") }}
          <v-icon dark>{{ this.translate("system.button.add.icon") }}</v-icon>
        </v-btn>
      </v-flex>

      <v-flex xs12 sm2>
        <p-date
          @input="mudarFiltros"
          name="dataI"
          v-model="filtros.dataInicio"
          :label="translate('table.' + entity + '.field.data') + ' Início'"
        ></p-date>
      </v-flex>

      <v-flex xs12 sm2>
        <p-date
          @input="mudarFiltros"
          name="dataF"
          v-model="filtros.dataFim"
          :label="translate('table.' + entity + '.field.data') + ' Fim'"
        ></p-date>
      </v-flex>

      <v-flex xs12 sm3>
        <v-text-field
          append-icon="search"
          label="Pesquisar"
          v-model="search"
          @change="updateSum"
        ></v-text-field>
      </v-flex>

      <v-flex xs12 sm1>
        <v-menu offset-y>
          <v-btn slot="activator" icon class="ml-2" title="Relatórios">
            <v-icon>description</v-icon>
          </v-btn>
          <v-list>
            <!-- PDF -->
            <v-list-tile @click="exportReport(1)">
              <v-list-tile-action>
                <v-icon color="red darken-1">picture_as_pdf</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Relatório em PDF</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <!-- Excel -->
            <v-list-tile @click="exportReport(2)">
              <v-list-tile-action>
                <v-icon color="green darken-2">table_chart</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Relatório em Excel</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-flex>
      <!--Index-->
      <v-flex xs12>
        <v-data-table
          ref="ControleCaixaTable"
          :headers="headers"
          :items="items"
          :search="search"
          class="elevation-1"
          :rows-per-page-items="[100, 50, 25, { text: 'Todos', value: -1 }]"
          rows-per-page-text="Registros por página"
          no-data-text="Não existem registros"
          no-results-text="Nenhum registro encontrado"
        >
          <template slot="items" slot-scope="props">
            <td align="center">{{ props.item.data | formatDate }}</td>
            <td align="center">{{ getCodigoImovelText(props.item.codigo_imovel) }}</td>
            <td align="center">{{ getCodigoContaText(props.item.codigo_conta) }}</td>
            <td align="center">{{ props.item.numero }}</td>
            <td align="center">{{ getTipoDocumentoText(props.item.tipo_documento) }}</td>
            <td align="center">{{ props.item.historico }}</td>
            <td align="center">{{ props.item.cpf_cnpj }}</td>
            <td align="center">{{ getTipoLancamentoText(props.item.tipo_lancamento) }}</td>
            <td align="center">{{ props.item.entrada | formatCurrency }}</td>
            <td align="center">{{ props.item.saida | formatCurrency }}</td>
            <td align="center">
              {{ (props.item.entrada - props.item.saida) | formatCurrency }}
            </td>
            <td align="center">
              {{ props.item.entrada - props.item.saida > 0 ? "Positivo" : "Negativo" }}
            </td>
            <td align="center" style="min-width: 150px">
              <v-btn
                icon
                class="mx-0"
                @click="editItem(props.item)"
                :disabled="!hasCondominioAccess(entity, 'update')"
              >
                <v-icon color="teal">edit</v-icon>
              </v-btn>
              <v-btn
                icon
                class="mx-0"
                @click="deleteItem(props.item)"
                :disabled="!hasCondominioAccess(entity, 'delete')"
              >
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </template>
          <template v-slot:footer>
            <td colspan="8">
              <strong>Total Geral</strong>
            </td>
            <td align="center">
              <strong>{{ sum.entrada | formatCurrency }}</strong>
            </td>
            <td align="center">
              <strong>{{ sum.saida | formatCurrency }}</strong>
            </td>
            <td align="center">
              <strong>{{ (sum.entrada - sum.saida) | formatCurrency }}</strong>
            </td>
          </template>
          <template slot="pageText" slot-scope="props">
            {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <!--Create Edit-->
    <v-dialog v-model="dialog" max-width="1600px" persistent>
      <v-card>
        <v-card-text>
          <v-container grid-list-md fluid>
            <v-layout wrap justify-center align-center>
              <v-flex xs12>
                <span class="display-1">{{ formTitle }}</span>
              </v-flex>

              <v-flex xs12 md3>
                <p-date
                  name="data"
                  v-model="editedItem.data"
                  data-vv-validate-on="blur"
                  v-validate="'required'"
                  :error-messages="errors.collect('data')"
                  :data-vv-as="translate('table.' + entity + '.field.data')"
                  :label="translate('table.' + entity + '.field.data')"
                  :v_validate="'required'"
                  :as="translate('table.' + entity + '.field.data')"
                  limitPreviousYears
                ></p-date>
              </v-flex>

              <v-flex xs12 md3>
                <v-autocomplete
                  name="codigo_imovel"
                  v-model="editedItem.codigo_imovel"
                  :label="translate('table.' + entity + '.field.codigo_imovel')"
                  @change="editedItem.codigo = null"
                  data-vv-validate-on="blur"
                  v-validate="'required'"
                  :error-messages="errors.collect('codigo_imovel')"
                  :data-vv-as="translate('table.' + entity + '.field.codigo_imovel')"
                  :items="itemsCodigoImovel"
                  item-text="id_texto"
                  item-value="id"
                ></v-autocomplete>
              </v-flex>

              <v-flex xs12 md3>
                <v-autocomplete
                  name="codigo_conta"
                  v-model="editedItem.codigo_conta"
                  :label="translate('table.' + entity + '.field.codigo_conta')"
                  @change="editedItem.codigo = null"
                  data-vv-validate-on="blur"
                  v-validate="'required'"
                  :error-messages="errors.collect('codigo_conta')"
                  :data-vv-as="translate('table.' + entity + '.field.codigo_conta')"
                  :items="itemsCodigoConta"
                  item-text="id_texto"
                  item-value="id"
                ></v-autocomplete>
              </v-flex>

              <v-flex xs12 md3>
                <v-text-field
                  name="numero"
                  :label="translate('table.' + entity + '.field.numero')"
                  v-model="editedItem.numero"
                  counter
                  maxlength="30"
                  v-validate="'required|max:30'"
                  data-vv-validate-on="blur"
                  :error-messages="errors.collect('numero')"
                  :data-vv-as="translate('table.' + entity + '.field.numero')"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 md4>
                <v-autocomplete
                  name="tipo_documento"
                  v-model="editedItem.tipo_documento"
                  data-vv-validate-on="blur"
                  v-validate="'required'"
                  :error-messages="errors.collect('tipo_documento')"
                  :data-vv-as="translate('table.' + entity + '.field.tipo_documento')"
                  :label="translate('table.' + entity + '.field.tipo_documento')"
                  :items="translate('value.controlecaixa_tipo_documento')"
                ></v-autocomplete>
              </v-flex>

              <v-flex xs12 md4>
                <v-text-field
                  name="banco"
                  :label="translate('table.' + entity + '.field.historico')"
                  v-model="editedItem.historico"
                  counter
                  maxlength="512"
                  v-validate="'required|max:512'"
                  data-vv-validate-on="blur"
                  :error-messages="errors.collect('banco')"
                  :data-vv-as="translate('table.' + entity + '.field.banco')"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 md4>
                <p-cpf-cnpj
                  name="cpf_cnpj"
                  v-model="editedItem.cpf_cnpj"
                  v_validate="required"
                ></p-cpf-cnpj>
              </v-flex>

              <v-flex xs12 md4>
                <v-autocomplete
                  name="tipo_documento"
                  :label="translate('table.' + entity + '.field.tipo_lancamento')"
                  v-model="editedItem.tipo_lancamento"
                  :items="translate('value.controlecaixa_tipo_lancamento')"
                  data-vv-validate-on="blur"
                  v-validate="'required'"
                  :error-messages="errors.collect('tipo_documento')"
                  :data-vv-as="translate('table.' + entity + '.field.tipo_documento')"
                ></v-autocomplete>
              </v-flex>

              <v-flex xs12 md4>
                <p-money
                  name="entrada"
                  :label="translate('table.' + entity + '.field.entrada')"
                  v-model="editedItem.entrada"
                  :v_validate="
                    editedItem.tipo_lancamento == 1 || editedItem.tipo_lancamento == 3
                      ? 'positiveNumber|requiredNumber'
                      : 'positiveNumber'
                  "
                ></p-money>
              </v-flex>

              <v-flex xs12 md4>
                <p-money
                  name="saida"
                  :label="translate('table.' + entity + '.field.saida')"
                  v-model="editedItem.saida"
                  :v_validate="
                    editedItem.tipo_lancamento == 2
                      ? 'positiveNumber|requiredNumber'
                      : 'positiveNumber'
                  "
                ></p-money>
              </v-flex>

              <!-- <v-flex xs12 md2>
                <p-money label="Saldo Final" :value="editedItem.entrada - editedItem.saida"></p-money>
              </v-flex>

              <v-flex xs12 md2>
                <v-text-field
                  disabled
                  :class="{ 'green-text-style': editedItem.entrada - editedItem.saida > 0, 'red-text-style': editedItem.entrada - editedItem.saida < 0}"
                  :label="translate('table.' + entity + '.field.natureza')"
                  :value="(editedItem.entrada - editedItem.saida > 0 ? 'Positivo' : (editedItem.entrada - editedItem.saida < 0 ? 'Negativo' : ' '))"
                ></v-text-field>
              </v-flex> -->

              <v-flex xs12>
                <v-btn class="mx-1" color="primary darken-2" :disabled="saving" :loading="saving" @click.native="save()">Salvar</v-btn>
                <v-btn class="mx-1" @click.native="close(400)">Cancelar</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import crud from "./../../mixin/crud";
import PDate from "../shared/PDate";
import PMoney from "../shared/PMoney";
import acl from "./../../mixin/acl";
import PCpfCnpj from "../shared/PCpfCnpj";

export default {
  components: {
    PDate,
    PMoney,
    PCpfCnpj,
  },
  mixins: [crud, acl],
  data: () => ({
    entity: "condominio_controlecaixa",
    items: [],
    itemsCodigoConta: [],
    itemsCodigoImovel: [],
    filtros: { dataInicio: "", dataFim: "" },
    filtrosAnterior: { dataInicio: "", dataFim: "" },
    sum: {
      entrada: 0,
      saida: 0,
    },
  }),
  name: "ControleCaixa",
  props: ["condominio_id"],
  created() {
    this.$http.get(`api/controle_caixa_fields/${this.condominio_id}`).then(
      (res) => {
        this.itemsCodigoImovel = res.body["codigoImovel"];
        this.itemsCodigoConta = res.body["codigoConta"];
        this.itemsCodigoConta.unshift({ id: 0, id_texto: "000 - Em espécie" });
        this.itemsCodigoConta.push({ id: 999, id_texto: "999 - Em espécie" });
      },
      (err) => {
        alert("Ocorreu um erro para carregar os dados");
      }
    );
    this.initialize();
    this.editedItem = {
      condominio_id: this.condominio_id,
      empresa_id: this.$auth.user().empresa_id,
      cpf_cnpj: "",
    };
    this.defaultItem = {
      condominio_id: this.condominio_id,
      empresa_id: this.$auth.user().empresa_id,
      cpf_cnpj: "",
    };
  },
  methods: {
    // type 1 = pdf, type 2 = excel
    exportReport (type) {
      this.$store.commit("loader/change_dialog", true);

      // Monta os filtros para passar ao backend
      const filters = {
        dataInicio: this.filtros.dataInicio || null,
        dataFim: this.filtros.dataFim || null,
        search: this.search || null
      };

      this.$http.put(`report/report_details/${this.condominio_id}`, {
        "type": type,
        "table": "condominio_controlecaixa",
        "filters": filters
      }).then(
        (res) => {
          let fileName = res.data;
          window.open(process.env.API + "reports/" + fileName, "_blank");
          this.$store.commit("loader/change_dialog", false);
          const _this = this;
          setTimeout(function () {
            _this.$http.delete(`report/delete_upload_report/${fileName}`)
          }, 5000)
        },
        (error) => {
          this.$store.commit("loader/change_dialog", false);
          this.$store.commit("snackbar/change_values", {
            text:
              error.body.message ||
              "Desculpe, não conseguimos gerar o relatório no momento. Por favor, tente novamente mais tarde.",
            color: "error",
            dialog: true,
          });
        }
      );
    },
    getCodigoImovelText (codigo) {
      const item = this.itemsCodigoImovel.find(c => c.id === codigo)
      return item ? item.id_texto : ''
    },
    getCodigoContaText (codigo) {
      const item = this.itemsCodigoConta.find(c => c.id === codigo)
      return item ? item.id_texto : codigo
    },
    getTipoDocumentoText (tipo) {
      const item = this.translate('value.controlecaixa_tipo_documento').find(c => c.value === tipo)
      return item ? item.text : ''
    },
    getTipoLancamentoText (tipo) {
      const item = this.translate('value.controlecaixa_tipo_lancamento').find(c => c.value === tipo)
      return item ? item.text : ''
    },
    mudarFiltros(val) {
      if (
        this.filtrosAnterior["dataInicio"] != this.filtros["dataInicio"] ||
        this.filtrosAnterior["dataFim"] != this.filtros["dataFim"]
      ) {
        this.filtrosAnterior["dataInicio"] = this.filtros["dataInicio"];
        this.filtrosAnterior["dataFim"] = this.filtros["dataFim"];
        this.initialize();
      }
    },
    initialize() {
      let where = `condominio_id=${this.condominio_id}`;
      if (this.filtros["dataInicio"] != "") where += ` AND data >= "${this.filtros["dataInicio"]}"`;
      if (this.filtros["dataFim"] != "") where += ` AND data <= "${this.filtros["dataFim"]}"`;

      this.$http.get(`api/condominio_controlecaixa?where=${where}`).then(
        (res) => {
          this.items = res.body["dados"];
        },
        (err) => {
          alert("Ocorreu um erro para carregar os dados");
        }
      );
    },
    updateSum() {
      let filteredItems = this.$refs.ControleCaixaTable.filteredItems;
      this.sum = filteredItems.reduce(
        (total, controleCaixa) => {
          return {
            entrada: total.entrada + Number(controleCaixa.entrada),
            saida: total.saida + Number(controleCaixa.saida),
          };
        },
        { entrada: 0, saida: 0 }
      );
    },
  },
  watch: {
    items(newValue, oldValue) {
      this.updateSum();
    },
  },
  computed: {
    headers: function () {
      return [
        {
          text: this.translate("table." + this.entity + ".field.data"),
          value: "data",
          align: "center",
        },
        {
          text: this.translate("table." + this.entity + ".field.codigo_imovel"),
          value: "codigo_imovel",
          align: "center",
        },
        {
          text: this.translate("table." + this.entity + ".field.codigo_conta"),
          value: "codigo",
          align: "codigo_conta",
        },
        {
          text: this.translate("table." + this.entity + ".field.numero"),
          value: "numero",
          align: "center",
        },
        {
          text: this.translate("table." + this.entity + ".field.tipo_documento"),
          value: "tipo_documento",
          align: "center",
        },
        {
          text: this.translate("table." + this.entity + ".field.historico"),
          value: "historico",
          align: "center",
        },
        {
          text: this.translate("table." + this.entity + ".field.cpf_cnpj"),
          value: "cpf_cnpj",
          align: "center",
        },
        {
          text: this.translate("table." + this.entity + ".field.tipo_lancamento"),
          value: "tipo_lancamento",
          align: "center",
        },
        {
          text: this.translate("table." + this.entity + ".field.entrada"),
          value: "entrada",
          align: "center",
        },
        {
          text: this.translate("table." + this.entity + ".field.saida"),
          value: "saida",
          align: "center",
        },
        {
          text: this.translate("table." + this.entity + ".field.saldo_final"),
          value: "saldo_final",
          align: "center",
        },
        {
          text: this.translate("table." + this.entity + ".field.natureza"),
          value: "natureza",
          align: "center",
        },
        {
          text: this.translate("system.table.action"),
          value: "action",
          sortable: false,
          align: "center",
          width: "10%",
        },
      ];
    },
  },
};
</script>

<style scoped>
.red-text-style >>> .v-text-field__slot input {
  color: red;
  font-weight: 500;
}

.green-text-style >>> .v-text-field__slot input {
  color: green;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/details/ControleCaixa.vue